module.exports = __webpack_public_path__ + "img/groups_mail_hdtool.10d8ed6a.png";